// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__i0JEp","errors":"Errors_errors__unkJz"};